'use strict';

angular.module('DoohApps').directive('ngPrism', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            Prism.highlightElement(element[0]);
        }
    }
});